
import { defineComponent, reactive, ref, computed, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { CloseCircleOutlined, EyeOutlined } from '@ant-design/icons-vue'
import { Select } from 'ant-design-vue'
import LoginNav from './LoginNav.vue'
import Inputpassword from '@/components/Common/Inputpassword.vue'
import loginService from '@/services/loginService'
import { getUrlQuery, mobileDesensitization } from '@/utils/utils'
import { Decrypt, Encrypt } from '@/utils/secret'
import { message } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'


export default defineComponent({
    components: {
        LoginNav,
        Inputpassword,
        CloseCircleOutlined,
        EyeOutlined,
        'a-select': Select,
        'a-select-option': Select.Option
    },
    props: {
        hideNav: {
            type: Boolean,
            // required: true,
            default: false
        },
        logoMode: {
            type: String,
            default: 'logo'
        },
        logoTitle: {
            type: String,
            default: '登录协同'
        }
    },
    setup() {
        const { t, locale } = useI18n()
        const currentLanguage = ref(locale.value)
        const store = useStore()
        const loading = ref(false)
        const hasLogin = ref(false) // 账号是否已登录
        const captchaVisible = ref(false)
        const isCaptchaValidatePass = ref(true) // 图形验证码是否校验通过，前三次默认为true
        const sendCount = ref(0)
        const checked = ref(false)
        const isClickLogin = ref(false)
        const warningInfo = reactive({
            title: '',
            show: false
        })
        const loginMode = ref(2) // loginMode 1:验证码登录  2:密码登录
        const loginForm = ref() // vue 3.0 使用ref获取dom元素
        const setpwdForm = ref()
        const isValidatePhonePass = ref(false)
        const isValidateAccount = ref(false)
        const isCanSend = ref(true)
        const firstStep = ref(true)
        const noPwd = ref(false)
        const noName = ref(false)
        const checkNamePass = ref(false)
        const setNameStatus = ref(false)
        const backRoute = ref(false) 
        const checkPass = ref(false)
        const account: any = ref(null)
        const formData = reactive({
            countryCode: '+86',
            phone: '',
            password: '',
            authCode: '',
            rememberMe: false,
            channel: 'pwd',
            mobile: '',
            newpassword: '',
            secpassword: '',
            terminal: 'web',
            name: '',
            tempMobile: '', // 临时保存手机号
            tempPassword: '' // 临时保存密码
        })
        const route = useRouter()
       
        const avatarUrl = ref('')
        const username = ref('')
        const userMobile = ref('')
        const pwdtype = ref('password')
        const passwordMin = ref(10)
        const passwordMax = ref(20)
        const hasBigLittleLetterRule = ref(false)
        const hasSpecialSymbolRule = ref(false)
        const agreementTips = ref(false)
        const verifyCodeTitle = ref(t('message.huoquyanzhengma'))
        const phoneClose = ref(true)
        const mobileClose = ref(true)
        const redirectUrl = ref('')
        const secStepPwd = ref('')
        const secStepName = ref('')
        const confirm = ref(false)
        let service = ''
        if (getUrlQuery('redirectURL')) {
            service = getUrlQuery('redirectURL') as string
        }
        let terminal = ''
        if (getUrlQuery('terminal')) {
            terminal = getUrlQuery('terminal') as string
        }
        const hasNumber = computed(() => {
            const reg = /\d/
            return reg.test(formData.newpassword)
        })
        const pwdSame = computed(() => {
            return (formData.newpassword && formData.secpassword && formData.newpassword !== formData.secpassword)
        })
        const hasLetter = computed(() => {
            const reg = /[A-Za-z]/
            return reg.test(formData.newpassword)
        })
        const hasBigLittleLetter = computed(() => {
            const reg = /(?=.*[a-z])(?=.*[A-Z])/
            return reg.test(formData.newpassword)
        })
        const hasSpecialSymbol = computed(() => {
            const reg = /\W/
            return reg.test(formData.newpassword)
        })
        const isOverSix = computed(() => {
            return formData.newpassword.length >= passwordMin.value
        })
        const isLessMax = computed(() => {
            return formData.newpassword.length <= passwordMax.value
        })
        const defaultloginPath = computed(() => {
            return route.currentRoute.value.path === '/' || route.currentRoute.value.path === '/custom'
        })
        // 校验手机号（验证码登录专用，只允许手机号）
        const validatePhoneAuth = (rule: any, value: any, callback: any) => {
            const phoneReg = /^\d+$/
            return new Promise<void>((resolve, reject) => {
                if (value.trim() === '') {
                    isValidatePhonePass.value = false
                    isValidateAccount.value = false
                    reject(t('message.enterAccount'))
                } else {
                    if (!phoneReg.test(value)) {
                        isValidatePhonePass.value = false
                        isValidateAccount.value = false
                        reject(t('message.pleaseEnterValidPhoneNumber'))
                    } else {
                        isValidatePhonePass.value = true
                        resolve()
                    }
                }
            })
        }
        // 校验手机号或邮箱（密码登录用）- 只校验数字和不为空
        const validatePhone = (rule: any, value: any, callback: any) => {
            // 检查是否为空
            if (value.trim() === '') {
                isValidatePhonePass.value = false
                isValidateAccount.value = false
                return Promise.reject(t('message.enterAccount'))
            }
            
            // 检查是否只包含数字
            const digitOnlyReg = /^\d+$/
            if (!digitOnlyReg.test(value)) {
                isValidatePhonePass.value = false
                isValidateAccount.value = false
                return Promise.reject(t('message.onlyDigitsAllowed'))
            }
            
            // 通过所有检查
            isValidatePhonePass.value = true
            return Promise.resolve()
        }
        // 校验账号 - 密码登录模式下只校验不能为汉字，其他的都可以
        const validateAccount = (rule: any, value: any, callback: any) => {
            return new Promise<void>((resolve, reject) => {
                if (value.trim() === '') {
                    isValidateAccount.value = false
                    reject(t('message.enterAccount'))
                } else {
                    // 检查是否包含中文字符
                    const chineseReg = /[\u4e00-\u9fa5]/
                    if (chineseReg.test(value)) {
                        isValidateAccount.value = false
                        reject(t('message.noChineseAllowed'))
                    } else {
                        isValidateAccount.value = true
                        resolve()
                    }
                }       
            })
        }
        // 校验密码
        const validatePassword = (rule: any, value: any, callback: any) => {
            return new Promise<void>((resolve, reject) => {
                if (value.trim() !== '' && formData.mobile.trim() !== '') {
                    resolve()
                } else if (value.trim() === '' && formData.mobile.trim() !== '') {
                    reject(t('message.qingshurumima'))
                }       
            })
        }
        // 验证验证码
        const validateCode = (rule: any, value: any, callback: any) => {
            const reg = /^[0-9]*$/
            return new Promise<void>((resolve, reject) => {
                if (formData.phone && firstStep.value) {
                    if (value.toString().trim() === '') {
                        reject(t('message.qingshuruyanzhengma'))
                    } else if (!reg.test(value)) {
                        reject(t('message.yanzhengmaweishuzi'))
                    } else if (reg.test(value) && value.toString().length !== 4) {
                        reject(t('message.yanzhengmageshicuowu'))
                    } else {
                        resolve()
                    }
                }
            })  
        }
        const validateCheckPassword = (rule: any, value: any, callback: any) => {
            return new Promise<void>((resolve, reject) => {
                if (value.trim() === '') {
                    checkPass.value = false
                    reject(t('message.qingzaicishurumima'))
                } else if (value !== formData.newpassword) {
                    checkPass.value = false
                    reject(t('message.liangcimimabuyizhi'))
                } else {
                    checkPass.value = true
                    resolve()
                }
            })
        }

        const validateCheckName = (rule: any, value: any, callback: any) => {
            return new Promise<void>((resolve, reject) => {
                if (value.trim() === '') {
                    checkNamePass.value = false
                    reject(t('message.qingshuruxingming'))
                } else {
                    checkNamePass.value = true
                    resolve()
                }
            })
        }
        const rules = {
            phone: [{ required: true, validator: validatePhoneAuth, trigger: 'blur' }],
            mobile: [{ required: true, validator: validateAccount , trigger: 'blur', }],
            password: [{ required: true, validator: validatePassword, trigger: 'blur' }],
            verifyCode: [{ required: true, validator: validateCode, trigger: 'blur' }],
            secpassword: [{ required: true, validator: validateCheckPassword, trigger: 'blur' }],
            name: [{ required: true, validator: validateCheckName, trigger: 'blur' }]
        }
        const changeLoginMode = (type: any) => {
            loading.value = false
            loginMode.value = type
            isClickLogin.value = false
            warningInfo.title = ''
            warningInfo.show = false
        }
        // 验证码
        const hasSend = ref(false)
        const countdown = ref(60)
        const handleClickSendVerifyCode = () => {
            if (((isCanSend.value && !isValidatePhonePass.value) || !isCanSend.value) && firstStep.value) {
                return
            }
            sendPhoneCode()
            hasSend.value = true
            let timer: any = null
            if (timer) {
                clearInterval(timer)
            }
            timer = setInterval(() => {
                if (countdown.value === 1) {
                    hasSend.value = false
                    countdown.value = 60
                    verifyCodeTitle.value = t('message.chongxinfasong')
                    clearInterval(timer)
                }
                countdown.value--
            }, 1000)
        }
        const sendPhoneCode = async () => {
            const query: any =  { mobile: formData.phone, usage: 'LOGIN', countryCode: formData.countryCode }
            terminal && (query.terminal = terminal)
            console.log(query)
            const res: any = await loginService.sendPhoneCode(query)
            console.log(res)
            if (res.code !== '200') {
                warningInfo.title = res.message
                warningInfo.show = true
                if (res.code === '4000000002') {
                    isCanSend.value = false
                }
                return
            }
            isCanSend.value = true
            // 发送次数逻辑
            if (res.data?.sendCount >= 0) {
                sendCount.value = res.data.sendCount
            }
            if (sendCount.value === 5) {
                // 发送验证码次数等于5
                warningInfo.title = t('message.yanzhengmadashangxian')
                warningInfo.show = true
                return
            }
            if (sendCount.value >= 3 && sendCount.value < 5) {
                // 发送验证码次数超过3次
                warningInfo.title = `${t('message.haikeyihuoqu')} ${5 - sendCount.value} ${t('message.ciyanzhengma')}`
                warningInfo.show = true
                isCaptchaValidatePass.value = false
            }
        }
        // 登录
        const login = () => {
            loading.value = true
            let query: any = {}
            if (loginMode.value ===1) {
                formData.channel = 'authcode'
                let {password, mobile, newpassword, secpassword, ...pick} = formData
                query = pick
                query.mobile = formData.phone
                query.countryCode = formData.countryCode
            } else {
                formData.channel = 'pwd'
                let {authCode, phone, newpassword, secpassword, countryCode, ...pick} = formData
                query = pick
                
                // 如果用户输入的账号全部为数字，则尝试匹配区号
                if (/^\d+$/.test(formData.mobile)) {
                    const mobileStr = formData.mobile
                    const countryCodes = ['86', '852', '853', '60', '65']
                    let matchedCode = ''
                    
                    for (const code of countryCodes) {
                        if (mobileStr.startsWith(code)) {
                            matchedCode = code
                            break
                        }
                    }
                    
                    if (matchedCode) {
                        query.countryCode = '+' + matchedCode
                        query.mobile = mobileStr.substring(matchedCode.length)
                    } else {
                        query.countryCode = '+86'
                    }
                }
            }
            if (loginMode.value === 2 && formData.rememberMe) {
                const word = JSON.stringify({ mobile: formData.mobile, password: formData.password, rememberMe: formData.rememberMe, countryCode: formData.countryCode })
                const userInfo = Encrypt(word)
                localStorage.setItem('cbimucUserInfo', userInfo)
            }
            if (!formData.rememberMe) {
                localStorage.removeItem('cbimucUserInfo')
            }
            query.backUrl = service ? service : ''
            query.terminal = terminal? terminal: 'web'
            confirm.value && (query.confirm = true)
            console.log(111111, query)
            
            loginService.login(query)
            .then((res: any) => {
                console.log(res, service, getUrlQuery('redirectURL'))
                if(res.code != 200 && !res.data) {
                    if(res.code === '4004000700003') {
                        showResetMessage()
                    }
                    if(res.code === '4004000700001') {
                        confirm.value = true
                    }
                    warningInfo.title = res.message
                    warningInfo.show = true
                    return 
                }
                if(!res.data?.hasPassword || !res.data?.hasName) {
                    warningInfo.title = ''
                    warningInfo.show = false
                    firstStep.value = false
                    if(!res.data?.hasPassword) {
                        noPwd.value = true
                        backRoute.value = true
                    }
                    if(!res.data?.hasName) {
                        setNameStatus.value = true
                    }
                    if(res.data?.hasPassword && !res.data?.hasName) {
                        noName.value = true
                        backRoute.value = false
                    }
                    userMobile.value = mobileDesensitization(formData.phone)

                    return
                }
                if(res.data?.redirectUrl) {
                    redirectUrl.value = res.data.redirectUrl
                    window.location.replace(res.data?.redirectUrl)
                }
            })
            .finally(() => {
                loading.value = false
            })
        }

        const showResetMessage = () => {
            const dom: any = document.querySelector('.login-main') ? document.querySelector('.login-main') : document.body
            message.config({
                getContainer: () => dom,
                top: '-48px'
            })
            message.info({
                content: t('message.shiyongwangjimima'),
                onClose: () => message.config({
                            getContainer: () => document.body,
                            top: '24px'
                        })
            })
        }
        // 忘记密码
        const forgetPassword = () => {
            const baseUrl = process.env.VUE_APP_DEPLOY === 'development' ? '/findpwd' : '/passport/findpwd/'
            const query = service ? `?redirectURL=${encodeURIComponent(service)}`:''
            const querySign = query.includes('?')?'&': '?' 
            const secQuery = terminal ? `terminal=${encodeURIComponent(terminal)}`: ''
            console.log(`${baseUrl}${query}${querySign}${secQuery}`)

            let url = `${baseUrl}${query}${querySign}${secQuery}`
            if(currentLanguage.value == 'en'){
                url += '&lang=en'
            }
            window.location.href = url
        }
        const handleChange = (e: any) => {
            if (loginMode.value === 1) {
                formData.phone = ''
            } else {
                formData.mobile = ''
            }
        }
        const register = () => {
            const baseUrl = process.env.VUE_APP_DEPLOY === 'development' ? '/signin' : '/passport/signin/'
            const query = service ? `?redirectURL=${encodeURIComponent(service)}`:''
            const querySign = query.includes('?')?'&': '?' 
            const secQuery = terminal ? `terminal=${encodeURIComponent(terminal)}`: ''
            let url = `${baseUrl}${query}${querySign}${secQuery}`
            if(currentLanguage.value == 'en'){
                url += '&lang=en'
            }
            window.location.href = url
        }
        
        const goToWechatAuth = () => {
            // 先校验是否勾选用户协议
            if (!checked.value) {
                agreementTips.value = true
                setTimeout(() => {
                    agreementTips.value = false
                }, 3000)
                return
            }
            
            const baseUrl = process.env.VUE_APP_DEPLOY === 'development' ? 'https://test6-gw.cbim.org.cn/cbim-uc/wechat/login/qrcode' : '/api/uc/wechat/login/qrcode'
            const query = service ? `?redirectURL=${encodeURIComponent(service)}`:`?redirectURL=${encodeURIComponent(window.location.origin)}`
            const querySign = query.includes('?')?'&': '?' 
            const secQuery = terminal ? `terminal=${encodeURIComponent(terminal)}`: ''
            let url = `${baseUrl}${query}${querySign}${secQuery}`
            if(currentLanguage.value == 'en'){
                url += '&lang=en'
            }
            window.location.href = url
        }
        const handleChangePwdtype = (type: string) => {
            pwdtype.value = type
        }
        const checkagreementAction = () => {
            if (!checked.value) {
                console.log('请勾选用户协议')
                agreementTips.value = true
                setTimeout(() => {
                    agreementTips.value = false
                }, 3000)
                return false
            }
            return true
        }
        // 点击登录
        const handleClickLogin = async () => {
            console.log(111,formData, isCanClick.value,checked.value)
            if (!isCanClick.value) {
                return
            }
            if(!checkagreementAction()) {
                return 
            }

            isClickLogin.value = true
            loading.value = true

            checkLoginStatus()
            // login()
        }

        const checkpwd = async() => {
            const params: {mobile: string, pwd: string, terminal?: string, countryCode?: string} = {
                mobile: loginMode.value === 1 ? formData.phone : formData.mobile,
                pwd: formData.password
            }
            if (loginMode.value === 1) {
                params.countryCode = formData.countryCode
            } else {
                // 如果用户输入的账号全部为数字，则尝试匹配区号
                if (/^\d+$/.test(formData.mobile)) {
                    const mobileStr = formData.mobile
                    const countryCodes = ['86', '852', '853', '60', '65']
                    let matchedCode = ''
                    
                    for (const code of countryCodes) {
                        if (mobileStr.startsWith(code)) {
                            matchedCode = code
                            break
                        }
                    }
                    
                    if (matchedCode) {
                        params.countryCode = '+' + matchedCode
                        params.mobile = mobileStr.substring(matchedCode.length)
                    } else {
                        params.countryCode = '+86'
                    }
                }
            }
            terminal && (params.terminal = terminal)
            const res: any = await loginService.checkPwdStatus(params)
            if (res.code === '200') {
                const lastRes: any = await loginService.checkLoginStatus(loginMode.value === 1 ? formData.phone : formData.mobile, terminal).catch(() => {loading.value = false})
                if (lastRes.code === '40018') {
                    // 已登录
                    hasLogin.value = true
                    isClickLogin.value = false
                    loading.value = false
                    return
                }
            } else {
                if(res.code === '4004000700003') {
                    showResetMessage()
                }
                warningInfo.title = res.message
                warningInfo.show = true
                loading.value = false
                return
            }
            hasLogin.value = false
            login()
        }

        const checkLoginStatus = async() => {
            const account = loginMode.value === 1 ? formData.phone : formData.mobile
            if(loginMode.value === 2) {
                await checkpwd()
                return
            }else {
                const res: any = await loginService.checkLoginStatus(account, terminal).catch(() => {loading.value = false})
                if (res.code === '40018') {
                    // 已登录
                    hasLogin.value = true
                    isClickLogin.value = false
                    loading.value = false
                    return
                }
            }
            hasLogin.value = false
            login()
        }

        const backFirstSetp = (type?: string ) => {
            if(backRoute.value && type === 'setName') {
                firstStep.value = false
                noPwd.value = true
                return 
            }
            firstStep.value = true
        }

        const isCanClick = computed(() => {
            if (!firstStep.value && noPwd.value) {
                return formData.phone && formData.newpassword && formData.secpassword && checkPass.value
            }
            if (!firstStep.value && noName.value) {
                // 直接判断姓名是否输入，不依赖checkNamePass
                return (formData.phone || formData.mobile) && formData.name && formData.name.trim().length > 0
            }
            if (loginMode.value === 1 && firstStep.value) {
                return isValidatePhonePass.value && formData.phone && formData.authCode
            }
            return isValidateAccount.value && formData.mobile && formData.password.length >= 1 
        })

        watch(loginMode, (newVal: number, oldVal: any) => {
            if (newVal === 2) {
                getLocalUserInfo()
            }else {
                // 切换到验证码登录时，也要判断是否为纯数字
                if (formData.mobile && /^\d+$/.test(formData.mobile)) {
                    formData.phone = formData.mobile
                    // 当切换到验证码登录模式时，如果之前有保存的手机号，应保留国家代码
                    loginForm.value.validateFields
                    validatePhoneAuth(null,formData.phone,null)
                } else {
                    formData.phone = ''
                    // 如果不是纯数字，不触发校验
                    isValidatePhonePass.value = false
                    isValidateAccount.value = false
                }
            }
        })

        onMounted(() => {
            if (loginMode.value == 2) {
                getLocalUserInfo()
                // hasLogin.value = true
            }
            console.log(route.currentRoute.value.path)
        })
        
        const getLocalUserInfo = () => {
            if (localStorage.getItem('cbimucUserInfo')) {
                const word = localStorage.getItem('cbimucUserInfo') as string
                if (word) {
                    const userInfo = JSON.parse(Decrypt(word))
                    
                    // 切换到验证码登录时，判断账号是否为纯数字
                    if (loginMode.value === 1) {
                        // 如果不是纯数字，不填充到 formData.phone
                        if (/^\d+$/.test(userInfo.mobile)) {
                            formData.phone = userInfo.mobile
                        } else {
                            formData.phone = ''
                        }
                    } else {
                        formData.phone = formData.mobile ? formData.mobile : userInfo.mobile
                    }
                    
                    formData.mobile = userInfo.mobile
                    formData.password = userInfo.password
                    formData.rememberMe = userInfo.rememberMe
                    // 如果本地存储中有国家代码信息，也应该加载
                    if (userInfo.countryCode) {
                        formData.countryCode = userInfo.countryCode
                    }
                    // 手动设置，让登录按钮可点击
                    isValidateAccount.value = true
                }
            }
        }
        const handleClear = (type: number) => {
            if (type === 1) {
                phoneClose.value = false
            } else {
                mobileClose.value = false
            }
        }
        const handleFoucs = (type: number) => {
            if (type === 1) {
                phoneClose.value = true
            } else {
                mobileClose.value = true
            }
        }
        const handleAgreement = () => {
            window.location.href = (process.env.VUE_APP_DEPLOY === 'development' ? '/agreement' : '/passport/agreement/') + (currentLanguage.value == 'en' ? `?lang=${currentLanguage.value}` : '')
        }
        const nextStep = () => {
            firstStep.value = false
            loading.value = false
            isClickLogin.value = false
        }
        const firstSetpwd = () => {
            getLocalUserInfo()
            if (!isCanClick.value) {
                return
            }
            loading.value = true
            let query: any = {}
            let {phone, newpassword, mobile, secpassword, countryCode } = formData
            console.log(1212121, phone, mobile)
            query = { mobile: loginMode.value === 1 ? phone : mobile, password: newpassword, usage: 'initial', authCode: 'cbim' }
            if (loginMode.value === 1) {
                query.countryCode = formData.countryCode
            }
            loginService.setpassword(query)
            .then((res: any) => {
                if(res.code != 200 && !res.data) {
                    warningInfo.title = res.message
                    warningInfo.show = true
                    loading.value = false
                    return 
                }
                if(setNameStatus.value) {
                    secStepName.value = formData.phone
                    secStepPwd.value = formData.newpassword
                    noPwd.value = false
                    noName.value = true
                    loading.value = false
                    return
                }
                loginByPwd()
            })
            .catch(() => {
                loading.value = false
            })
        }

        const firstSetname = async () => {
            getLocalUserInfo()
            
            // 如果没有勾选记住密码，手动保存当前用户信息供后续使用
            if (!formData.rememberMe) {
                // 保存当前表单中的用户信息到临时变量
                const currentUserInfo = {
                    mobile: loginMode.value === 1 ? formData.phone : formData.mobile,
                    password: formData.password,
                    rememberMe: false
                }
                // 临时保存到formData中，供后续loginByPwd使用
                formData.tempMobile = currentUserInfo.mobile
                formData.tempPassword = currentUserInfo.password
                isValidateAccount.value = true
            }

            console.log(212121,formData, isCanClick.value)
            
            if (!isCanClick.value) {
                return
            }
            loading.value = true
            
            let { phone, mobile, name, countryCode } = formData
            const params: { mobile: string, name: string, countryCode?: string } = {
                mobile: loginMode.value === 1 ? phone: mobile,
                name
            }
            if (loginMode.value === 1) {
                params.countryCode = formData.countryCode
            }
            
            const res: any = await loginService.setUsername(params).finally(() => {
                loading.value = false
            })
            
            if(res.code != 200 && !res.data) {
                warningInfo.title = res.message
                warningInfo.show = true
                return 
            }
            loginByPwd('setName')
        }

        const continueLogin = async () => {
            hasLogin.value = false
            // handleClickLogin()
            const mobile = loginMode.value === 1 ? formData.phone : formData.mobile
            const params: { countryCode?: string } = {}
            if (loginMode.value === 1) {
                params.countryCode = formData.countryCode
            }
            const res = await loginService.setKickStatus(mobile, params)
            console.log(res)
            await login()
        }

        const loginByPwd = (type?: string) => {
            let query: any = {}
            formData.channel = 'pwd'
            let {authCode, phone, password, newpassword, secpassword, ...pick} = formData
            console.log(formData)
            query = pick
            console.log(2121, secStepPwd.value, password)
            
            // 优先使用临时保存的用户信息（当没有勾选记住密码时）
            if (type === 'setName' && !formData.rememberMe && formData.tempMobile && formData.tempPassword) {
                query.mobile = formData.tempMobile
                query.password = formData.tempPassword
                query.countryCode = loginMode.value === 1 ? formData.countryCode : undefined
            } else {
                query.mobile = secStepName.value?secStepName.value:formData.mobile
                query.password = secStepPwd.value?secStepPwd.value:password
                if (loginMode.value === 1) {
                    query.countryCode = formData.countryCode
                } else {
                    // 如果用户输入的账号全部为数字，则尝试匹配区号
                    if (/^\d+$/.test(formData.mobile)) {
                        const mobileStr = formData.mobile
                        const countryCodes = ['86', '852', '853', '60', '65']
                        let matchedCode = ''
                        
                        for (const code of countryCodes) {
                            if (mobileStr.startsWith(code)) {
                                matchedCode = code
                                break
                            }
                        }
                        
                        if (matchedCode) {
                            query.countryCode = '+' + matchedCode
                            query.mobile = mobileStr.substring(matchedCode.length)
                        } else {
                            query.countryCode = '+86'
                        }
                    } else {
                        delete query.countryCode
                    }
                }
            }
            
            query.backUrl = service ? service : ''
            query.terminal = terminal? terminal: 'web'
            console.log('01010101', query)
            loginService.login(query)
            .then((res: any) => {
                console.log(res, service, getUrlQuery('redirectURL'))
                if(res.code != 200 && !res.data) {
                    if(res.code === '4004000700003') {
                        showResetMessage()
                    }
                    warningInfo.title = res.message
                    warningInfo.show = true
                    return 
                }
                if(!res.data?.hasPassword) {
                    warningInfo.title = ''
                    warningInfo.show = false
                    firstStep.value = false
                    userMobile.value = mobileDesensitization(formData.phone)
                    return
                }
                if(res.data?.redirectUrl) {
                    redirectUrl.value = res.data.redirectUrl
                    // window.location.href = res.data?.redirectUrl
                    window.location.replace(res.data?.redirectUrl)
                }
            })
            .finally(() => {
                loading.value = false
            })
        }

        return {
            currentLanguage,
            loading,
            hasLogin,
            warningInfo,
            checked,
            formData,
            rules,
            loginMode,
            changeLoginMode,
            getLocalUserInfo,
            loginForm,
            setpwdForm,
            hasSend,
            countdown,
            captchaVisible,
            isCanSend,
            isValidatePhonePass,
            isCanClick,
            isCaptchaValidatePass,
            handleClickSendVerifyCode,
            forgetPassword,
            handleClickLogin,
            isLocal: false,
            handleClear,
            handleAgreement,
            backFirstSetp,
            firstStep,
            nextStep,
            avatarUrl,
            username,
            userMobile,
            account,
            handleChange,
            pwdtype,
            handleChangePwdtype,
            agreementTips,
            hasNumber,
            hasLetter,
            hasBigLittleLetter,
            hasSpecialSymbol,
            isOverSix,
            isLessMax,
            passwordMin,
            passwordMax,
            hasBigLittleLetterRule,
            hasSpecialSymbolRule,
            verifyCodeTitle,
            handleFoucs,
            mobileClose,
            phoneClose,
            pwdSame,
            firstSetpwd,
            continueLogin,
            defaultloginPath,
            register,
            goToWechatAuth,
            loginByPwd,
            noPwd,
            noName,
            checkNamePass,
            firstSetname,
        }
    }
})
